import { palette } from "@dev/ee-components";
import styled from "styled-components";

export const TableContainer = styled.div`
    display: flex;
    height: 100%;
    padding: 8px;

    .MuiPaper-root {
        margin-bottom: 0;
    }
    .MuiTable-root {
        margin-bottom: 0 !important;
    }
    .MuiTableCell-head, .cellWrapperCustomTable, .MuiTableSortLabel-root {
        padding: 0 !important;
    }
    tr td.single-row--cell:nth-last-child(2) {
        padding-right: 0 !important;
    }
    .templatePreviewWrapper {
        width: 68px;
        height: 64px;
    }
    .typography-text-box {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
`;

export const MobileTableContainer = styled.div`
    width: 100%;
    margin: 8px 0;
    .MuiTableCell-body {
        border-bottom: 0;
    }
    .cardMobileCard {
        margin-bottom: 16px;
    }
    div .cardMobileCard:last-child {
        margin-bottom: 0;
    }
    .MuiTableCell-body .MuiGrid-root.MuiGrid-item:last-child, .typography-text-box {
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
    }
`;

export const EmptyStateContainer = styled.div<{$isMobile: boolean}>`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 54px 8px;
    justify-content: center;
    height: 100%;
    padding: ${({$isMobile}) => $isMobile ? '8px' : '54px 8px'};
`;

export const IconContainer = styled.div`
    padding-right: 8px;
    color: ${palette.indigo[6]};
`;
